// extracted by mini-css-extract-plugin
export default {"selectDeliveryDate":"style_selectDeliveryDate__qlP9x","card":"style_card__bGlsH","active":"style_active__Z3Yvu"};